import { isFloat } from '../is-float/is-float';
import { isInt } from '../is-int/is-int';

/**
 * Ez megmondja egy ertek tipusrol hogy number tipus-e
 * @param n
 */
export function isNumber(n: unknown): n is number {
  return isInt(n) || isFloat(n);
}
